/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Data: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5 2.5C11.9477 2.5 11.5 2.94772 11.5 3.5V12.5C11.5 13.0523 11.9477 13.5 12.5 13.5H21.5C22.0523 13.5 22.5 13.0523 22.5 12.5C22.5 6.97715 18.0228 2.5 12.5 2.5ZM13.5 11.5V4.56189C17.1187 5.01314 19.9869 7.88128 20.4381 11.5H13.5ZM9.56379 5.92695C10.0757 5.71972 10.3227 5.13673 10.1155 4.62479C9.90829 4.11286 9.3253 3.86584 8.81336 4.07307C5.40632 5.45221 3 8.79303 3 12.6983C3 17.8355 7.16452 22 12.3017 22C16.207 22 19.5478 19.5937 20.9269 16.1866C21.1342 15.6747 20.8871 15.0917 20.3752 14.8845C19.8633 14.6773 19.2803 14.9243 19.0731 15.4362C17.9891 18.114 15.3645 20 12.3017 20C8.26909 20 5 16.7309 5 12.6983C5 9.63553 6.88602 7.01088 9.56379 5.92695Z'
      fill='currentColor'
    />
  </React.Fragment>
)
